/* FleetPro Filters Module v1.0.0 - fp-oem-search.js
   Makes the HEADER search bar answer cross-reference numbers.

   Additive, standalone, safe to remove: every path falls through to native
   Shopify search unchanged when the index misses, fails to load, or the term is
   not a part number.

   THE PROBLEM
   -----------
   There are two search boxes on this site. The homepage hero part-number box
   reads fp-oem-index.json; the header bar is Shopify's native search, which
   indexes title / description / tags / vendor / SKU and NEVER a metafield. Our
   cross-references live in the custom.oem_cross_references metafield, so the
   header bar could only find one by accident - when the same number had also
   been typed into the title or tags. Measured: 2,250 of 4,542 values, 49.5%,
   were unreachable from the box on every page.

   ONE NUMBER OFTEN MEANS SEVERAL PRODUCTS
   ---------------------------------------
   9% of index keys hit more than one product, and that is not a data defect -
   it is variants. Volvo prints ONE fog-lamp number across four housings
   (black / white / with DRL / without), so `35829` legitimately returns four
   LH lamps. Auto-redirect therefore fires ONLY on a single hit; on several the
   customer goes to the search page and picks the variant - guessing for them is
   how you ship the wrong housing.

   NATIVE SEARCH OWNS THE RESULTS PAGE
   -----------------------------------
   This script never draws over a page that already has products on it. Shopify's
   grid has the photo, the price, the stock badge and the filters; a hand-rolled
   card list has none of them and is strictly worse. The only thing left here is
   the MISS: an empty results page for a number we can resolve. Measured on the
   current index: 143 of 4,598 keys are both multi-hit and absent from every
   title / SKU / tag, and that set is what this rescues. Put those numbers into a
   field Shopify indexes and this whole branch becomes dead code - delete it then.

   Debug: window.__fpFiltersDebug = true */
(function () {
  if (window.__fpOemSearch) return; window.__fpOemSearch = true;

  var fp = (window.fpFilters = window.fpFilters || { version: '1.0.0', loaded: {} });
  fp.loaded.oemSearch = '1.0.0';

  function warn() {
    if (window.__fpFiltersDebug && window.console && console.warn)
      console.warn.apply(console, ['[fp-filters/oem]'].concat([].slice.call(arguments)));
  }

  function indexUrl() {
    var el = document.querySelector('[data-fp-oem-index]');
    if (el) return el.getAttribute('data-fp-oem-index');
    return (window.FP_OEM_INDEX_URL || null);
  }

  function el(tag, cls, txt) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (txt != null) n.textContent = txt;
    return n;
  }

  /* fp-hero.js injects the .fp-oemhit card styles scoped to `.fp-hero`, so they
     do not reach the search page. Same brand tokens, own scope, injected once. */
  function styles() {
    if (document.getElementById('fp-oemblock-css')) return;
    var s = document.createElement('style');
    s.id = 'fp-oemblock-css';
    s.textContent =
      '.fp-oemblock{background:#F7F9FC;border:1px solid #E3E8EF;border-radius:12px;padding:16px 18px;margin:0 0 22px}' +
      '.fp-oemblock__h{margin:0;font-size:16px;font-weight:700;color:#0B1E3F}' +
      '.fp-oemblock__sub{margin:4px 0 0;font-size:13px;color:#5A6675}' +
      '.fp-oemblock__list{display:grid;gap:9px;margin-top:12px}' +
      '@media(min-width:750px){.fp-oemblock__list{grid-template-columns:repeat(2,minmax(0,1fr))}}' +
      '.fp-oemblock .fp-oemhit{display:block;background:#fff;border:1px solid #E3E8EF;border-radius:10px;padding:11px 13px;text-decoration:none;transition:border-color .15s}' +
      '.fp-oemblock .fp-oemhit:hover{border-color:#6F9DF5}' +
      '.fp-oemblock .fp-oemhit b{display:block;font-size:14px;color:#0B1E3F}' +
      '.fp-oemblock .fp-oemhit__sku{display:block;font:500 12px/1.4 "Roboto Mono",ui-monospace,Menlo,Consolas,monospace;color:#5A6675;margin-top:2px}' +
      '.fp-oemblock .fp-oemhit__x{display:block;font-size:12px;color:#5A6675;margin-top:4px}';
    document.head.appendChild(s);
  }

  /* ---------------------------------------------------------------- submit */
  /* Intercept the header form. On exactly one hit go straight to the product;
     otherwise do nothing and let the form submit as it always did. The lookup
     is bounded by a timeout so a slow index can never hold up a search. */
  function hookForms() {
    var forms = document.querySelectorAll('form[action$="/search"], form[action*="/search?"]');
    Array.prototype.forEach.call(forms, function (form) {
      if (form.__fpOem) return; form.__fpOem = true;
      form.addEventListener('submit', function (ev) {
        if (form.__fpGo) { form.__fpGo = false; return; }
        var input = form.querySelector('input[type=search], input[name=q]');
        var raw = input && (input.value || '').trim();
        if (!raw || !window.FPOEM || !window.FPOEM.looksLikePartNumber(raw)) return;
        var url = indexUrl();
        if (!url) return;

        ev.preventDefault();
        var settled = false;
        var go = function () {
          if (settled) return; settled = true;
          form.__fpGo = true;
          if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
        };
        setTimeout(go, 1200);                       // never block the customer

        window.FPOEM.lookup(raw, url).then(function (res) {
          if (settled) return;
          if (res.hits.length === 1) {
            settled = true;
            window.location.href = '/products/' + res.hits[0].handle;
            return;
          }
          go();                                     // 0 or many -> normal search
        }).catch(function (e) { warn('lookup failed', e); go(); });
      });
    });
  }

  /* ----------------------------------------------------------- results page */
  /* RESCUE ONLY - never decoration.

     This used to render whenever the index had hits, with no regard for what
     native search had already done. On `82775826` that stacked nine plain cards
     on top of ten real product tiles that were already correct: same parts,
     no photo, no price, no add-to-cart. Shopify's own search is the better
     surface whenever it answers at all, including when it answers loosely -
     that number is only in ONE title, and native still returned the whole
     Gen 3 fog-lamp family by matching 8277582x.

     So: if the grid has products, do nothing. The block exists for the miss. */
  /* Measured on the live page, because guessing here is how you get it backwards:
     with results, `#ProductGridContainer` exists and holds the tiles; with none,
     the section does not render it at all. So its ABSENCE is the empty signal.

     Do NOT fall back to `.template-search` - that wrapper contains the site
     header, and the mega-menu alone put 74 `/products/` links inside it on a
     page showing zero results. Counting those would report "native found
     products" on exactly the page the rescue exists for. */
  function nativeFoundProducts() {
    var grid = document.querySelector('.template-search__results, #ProductGridContainer');
    if (!grid) return false;
    var links = grid.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      if (!(links[i].closest && links[i].closest('.fp-oemblock'))) return true;
    }
    return false;
  }

  function rescueEmptySearch() {
    var m = /[?&]q=([^&]*)/.exec(window.location.search);
    if (!m) return;
    var raw = decodeURIComponent(m[1].replace(/\+/g, ' ')).trim();
    if (!raw || !window.FPOEM || !window.FPOEM.looksLikePartNumber(raw)) return;
    if (nativeFoundProducts()) return;           // real results beat our cards
    var url = indexUrl();
    if (!url) return;

    window.FPOEM.lookup(raw, url).then(function (res) {
      if (!res.hits.length) return;

      /* One product and an empty page - just take them there. Reached by the
         hero box's miss path, a bookmark, or the form's 1200ms timeout, none of
         which went through the single-hit redirect on submit. */
      if (res.hits.length === 1) {
        window.location.replace('/products/' + res.hits[0].handle);
        return;
      }

      var mount = document.querySelector('.template-search__results, #ProductGridContainer, .template-search');
      if (!mount) return;
      if (document.querySelector('.fp-oemblock')) return;

      styles();
      var box = el('section', 'fp-oemblock');
      box.setAttribute('role', 'region');
      box.setAttribute('aria-label', 'Cross-reference matches');
      box.appendChild(el('h2', 'fp-oemblock__h',
        res.hits.length + ' parts match ' + raw));
      box.appendChild(el('p', 'fp-oemblock__sub',
        'This number covers several variants — check the description and SKU before ordering.'));
      var list = el('div', 'fp-oemblock__list');
      res.hits.forEach(function (h) {
        var a = el('a', 'fp-oemhit');
        a.href = '/products/' + h.handle;
        a.appendChild(el('b', '', h.title || h.sku || 'View product'));
        a.appendChild(el('span', 'fp-oemhit__sku', 'SKU ' + (h.sku || '—')));
        a.appendChild(el('span', 'fp-oemhit__x', 'Matches ' + raw + ' via cross-reference'));
        list.appendChild(a);
      });
      box.appendChild(list);
      mount.insertBefore(box, mount.firstChild);
    }).catch(function (e) { warn('search page lookup failed', e); });
  }

  function init() { hookForms(); rescueEmptySearch(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  setTimeout(hookForms, 1500);   // headers that mount their form late
})();
